export enum WebsiteUrlType {
  Pretty = 'pretty',
  Real = 'real',
  Both = 'both',
}
